import * as React from 'react';
import {
  DialogProps,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
} from '@material-ui/core';
import { useStyles } from './styles';
import CloseIcon from '@material-ui/icons/Close';
import { ShopAllocation } from 'interfaces';

interface Props {
  dialogProps: DialogProps;
  shops: ShopAllocation[];
  onSelect: (id: number) => void;
}

export const ShopChooserDialog: React.FC<Props> = ({
  dialogProps,
  shops,
  onSelect,
}) => {
  const classes = useStyles();

  return (
    <Dialog fullWidth open={dialogProps.open} onClose={dialogProps.onClose}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={dialogProps.onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Choose a shop
          </Typography>
        </Toolbar>
      </AppBar>
      <List>
        {shops.map((shop, key) => (
          <React.Fragment key={key}>
            <ListItem button onClick={() => onSelect(shop.shopId)}>
              <ListItemText primary={shop.shop.title} />
            </ListItem>
            {key !== shops.length - 1 ? <Divider /> : ''}
          </React.Fragment>
        ))}
      </List>
    </Dialog>
  );
};
